// Branches are part of the Koerier Plus subscription
export default function branchesAvailable(reseller?: {accountType?: string} | null) {
    return reseller?.accountType === 'carrierPlus'
}
